exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".userAdminPage .search {\n  margin-left: 10px;\n}\n", "", {"version":3,"sources":["/home/guille/chinespain/tripmaker-redux/src/app/users/UsersAdminPage.less","/home/guille/chinespain/tripmaker-redux/src/app/users/UsersAdminPage.less"],"names":[],"mappings":"AAAA;EAEI,kBAAA;CCAH","file":"UsersAdminPage.less","sourcesContent":[".userAdminPage {\n  .search {\n    margin-left: 10px;\n  }\n}",".userAdminPage .search {\n  margin-left: 10px;\n}\n"],"sourceRoot":""}]);

// exports
